import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { IntlProvider } from "react-intl";
import messages_en from "./translations/en.json";
import messages_zhTW from "./translations/zh-TW.json";
import messages_zhCN from "./translations/zh-CN.json";
import qs from "qs";
import axios from "axios";
import Register from "./Register";
import { config } from "./utils/config";

const messages = {
  en: messages_en,
  "zh-CN": messages_zhCN,
  "zh-TW": messages_zhTW
};

function App() {
  const [language, setLanguage] = useState("zh-TW");
  const [data, setData] = useState(null);
  useEffect(() => {
    const { lang } = qs.parse(window.location.search.slice(1));
    if (lang === "en" || lang === "zh-CN") {
      setLanguage(lang);
    } else {
      setLanguage("zh-TW");
    }
  }, [window.location.search, setLanguage]);

  useEffect(() => {
    axios.get(config.endpoint).then(({ data }) => {
      setData(data);
    });
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <IntlProvider locale={language} messages={messages[language]}>
        <Switch>
          <Route path="/">
            <Register data={data} />
          </Route>
          <Redirect to="/" />
        </Switch>
      </IntlProvider>
    </Router>
  );
}

export default App;
